module.exports = __webpack_public_path__ + "img/huazhanglogo.656b7492.png";